// src/components/ui/AdminIncomeTaxReportHeader.jsx
import React from "react";

const AdminCourseImagesHeader = ({
  title = "ניהול תמונות לקורסים",
  subtitle = "בחר קטגוריה, הצג תמונות, העלה תמונות חדשות או מחק קיימות.",
}) => {
  return (
    <section className="mx-auto max-w-7xl px-2 sm:px-4 md:px-6 lg:px-8 py-3" dir="rtl">
      <div className="relative overflow-hidden rounded-3xl">
        <div className="absolute inset-0 bg-gradient-to-br from-indigo-50 via-purple-25 to-blue-50" />

        <div className="relative bg-white/80 backdrop-blur-xl border border-white/60 rounded-3xl p-6 shadow-2xl shadow-indigo-100/50">
          <div className="flex items-center gap-4">
            <div className="flex-shrink-0 w-12 h-12 rounded-2xl bg-gradient-to-br from-indigo-500 to-purple-600 text-white flex items-center justify-center shadow-md">
              <svg viewBox="0 0 24 24" className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="1.8">
                <rect x="3" y="5" width="18" height="14" rx="2" />
                <circle cx="9" cy="10" r="2" />
                <path d="M21 16l-4.5-4.5L10 18l-2-2-5 5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>

            <div className="min-w-0">
              <h1 className="text-2xl sm:text-3xl font-bold bg-gradient-to-r from-gray-900 via-indigo-800 to-purple-800 bg-clip-text text-transparent leading-tight">
                {title}
              </h1>
              <p className="text-gray-600 mt-1 truncate">{subtitle}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdminCourseImagesHeader;
